import { tsx } from "esri/widgets/support/widget";

const CSS = {
  base: "top-nav",
  title: "top-nav-title",
  text_large: "top-nav-text-large",
  text_small: "top-nav-text-small"
};

interface HeaderProperties {
  appName: string;
  appNotice: string;
  appNoticeStart: string;
  appNoticeEnd: string;
}

export const Header = (props: HeaderProperties) => (
  <header class={CSS.base}>
    <span class={CSS.title}>
      <img src="./assets/logo_white.png" alt="IDOT" height="20" />
    </span>
    <span class={CSS.text_large}  id="TopNavLargeText">{props.appName}</span>
    <span class={CSS.text_small}>IROADS</span>
    <span class="top-nav-access" id="privilegedUser" ></span>
    <span class="top-nav-notice" id="TopNavNotice">{props.appNotice}</span>
    <span class="layerSelect" id="selectLayer" />
    <span class="pinLabel" id="labelPin">
      Push Pin Label : <input type="text" name="pinLabelText" id="pinLabelText" style="width:150px" />
    </span>
  </header>
);
